export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  readonly size?: SpinnerSize;
  /** Block layout — centers the spinner in its parent (loading screens). */
  readonly block?: boolean;
  /** Accessible label. Defaults "Loading". */
  readonly label?: string;
  readonly className?: string;
}

/**
 * Looping spinner. Mirrors HTHD admin Spinner sizes and adds an optional
 * `block` mode for full-row / full-screen loading states.
 */
export function Spinner({
  size = 'md',
  block = false,
  label = 'Loading',
  className = '',
}: SpinnerProps): JSX.Element {
  const cls = [
    'ferro-spinner',
    `ferro-spinner--${size}`,
    block ? 'ferro-spinner--block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span role="status" aria-label={label} className={cls}>
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.2" />
        <path
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <span className="ferro-spinner__sr">{label}</span>
    </span>
  );
}
